module.exports = __webpack_public_path__ + "img/Running a node.903728f0.svg";